import React from 'react';
import { PvsDesignSystemProvider } from 'pvs-design-system';

const ThemeProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <PvsDesignSystemProvider>{children}</PvsDesignSystemProvider>;
};

export default ThemeProvider;
